export const mainNum = 5

export const FIELD_REMOVE_SPACES = ['sku_barcode']

export const EXTRA_FIELD_IDS = [
    'sku_barcode',
    'sku_MarketTime',
    'sku_official_price',
    'sku_ProductCode',
    'sku_HdHeight',
    'sku_HdLength',
    'sku_HdWidth',
    'hscode',
    'mic_price_wall_max_length',
    'mic_price_hd_length',
    'mic_price_light',
    'mic_price_hd_height',
    'skuCombineContent',
]

// sku 额外字段 有就显示
export const SKU_PICTURE = 'skuPicture' // sku 图片
export const SKU_TITLE = 'skuTitle' // sku 标题

/** 铺货模板 AI 打标字段（值与 templatePropId / aiFullItemId 一致，行尾为中文说明） */
export const SHELF_TEMPLATE_MAP = {
    ITEM_NAME: 'ITEM_NAME', // 标题-截取 (自定义)
    SKU_STOCK: 'SKU_STOCK', // 库存
    SKU_PRICE: 'SKU_PRICE', // 价格
    SHELVES_TYPE: 'SHELVES_TYPE', // 上架设置
}
